<script>
  import axios from "axios";
  import Modal from "common/components/Modal";
  import Icon from "common/components/icons/Icon";
  import NoSymbol from "common/components/icons/NoSymbol";
  import getCsrfToken from "common/utils/getCsrfToken";

  export let url = "";
  export let strings = {};

  let isShown = false;

  const show = () => (isShown = true);
  const hide = () => (isShown = false);
  const unsubscibe = (close) => {
    axios
      .put(
        `${url}`,
        {},
        {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Accept: "application/json",
            "X-CSRF-Token": getCsrfToken(),
          },
        }
      )
      .then((res) => {
        close();
        window.location.href = res.data.url;
      })
      .catch((err) => console.log(err));
  };
</script>

<button class="medium-secondary-button" on:click={() => show()}>
  <Icon width="24" height="24" name="no-symbol">
    <NoSymbol />
  </Icon>

  <span>{strings.cancel}</span>
</button>

<Modal
  let:close
  on:close={() => (isShown = false)}
  visible={isShown}
  width="500px">
  <div class="mb-6 text-base text-center">
    {strings.subscription_data}
  </div>
  <div class="flex justify-center gap-2 mb-3">
    <button class="medium-primary-button" on:click={() => close()}>
      {strings.subscibed}
    </button>
    <button class="medium-secondary-button" on:click={() => unsubscibe(close)}>
      {strings.unsubscibe}
    </button>
  </div>
</Modal>
